/**
 * @generated SignedSource<<bc908737781041e6b91a4aa43c1fd438>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type stakeholdersMergePage_Query$variables = {
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  perspectiveId?: string | null | undefined;
  search?: string | null | undefined;
  sort?: string | null | undefined;
  sortDir?: string | null | undefined;
};
export type stakeholdersMergePage_Query$data = {
  readonly costStakeholders: {
    readonly stakeholders: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly total: number;
      readonly txnCount: number;
    }>;
    readonly totalCount: number;
  };
};
export type stakeholdersMergePage_Query = {
  response: stakeholdersMergePage_Query$data;
  variables: stakeholdersMergePage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDir"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "perspectiveId",
        "variableName": "perspectiveId"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      },
      {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort"
      },
      {
        "kind": "Variable",
        "name": "sortDir",
        "variableName": "sortDir"
      }
    ],
    "concreteType": "CostStakeholdersPayload",
    "kind": "LinkedField",
    "name": "costStakeholders",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Stakeholder",
        "kind": "LinkedField",
        "name": "stakeholders",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "txnCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholdersMergePage_Query",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "stakeholdersMergePage_Query",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "46bd018eb34421d23108606ccadbdd1b",
    "id": null,
    "metadata": {},
    "name": "stakeholdersMergePage_Query",
    "operationKind": "query",
    "text": "query stakeholdersMergePage_Query(\n  $perspectiveId: ID\n  $search: String\n  $sort: String\n  $sortDir: String\n  $limit: Int\n  $offset: Int\n) {\n  costStakeholders(perspectiveId: $perspectiveId, search: $search, sort: $sort, sortDir: $sortDir, limit: $limit, offset: $offset) {\n    totalCount\n    stakeholders {\n      id\n      name\n      total\n      txnCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9a7e5e6ff18d313200265fd7ee8f891";

export default node;
